import React from "react";
import CosmicSubpageShell from "@/components/CosmicSubpageShell";
import PrintsShop from "@/components/PrintsShop";

export default function PrintsPage() {
  return (
    <CosmicSubpageShell testId="prints-page">
      <PrintsShop />
    </CosmicSubpageShell>
  );
}
